import * as Yup from "yup";

/**
 * Signup password rules — the same ones the server enforces
 * (backend validations/CustomValidation.js). They used to be "6 characters or
 * more" here, so a password like "sunshine" passed the form and was then
 * rejected by the server with a toast (Asher's dad, 2026-10-16, twice).
 * PASSWORD_RULES drives the live checklist under the signup password field.
 */
export const PASSWORD_MIN = 8;
export const PASSWORD_MAX = 128;

export const PASSWORD_RULES: { id: string; label: string; test: (pw: string) => boolean }[] = [
  { id: "length", label: `At least ${PASSWORD_MIN} characters`, test: (pw) => pw.length >= PASSWORD_MIN },
  { id: "upper", label: "An uppercase letter (A–Z)", test: (pw) => /[A-Z]/.test(pw) },
  { id: "lower", label: "A lowercase letter (a–z)", test: (pw) => /[a-z]/.test(pw) },
  { id: "digit", label: "A number (0–9)", test: (pw) => /\d/.test(pw) },
];

export const meetsPasswordRules = (pw: string) =>
  pw.length <= PASSWORD_MAX && PASSWORD_RULES.every((r) => r.test(pw));

export const loginYupValidation = Yup.object({
  // Trimmed: a phone keyboard's autocomplete often leaves a trailing space,
  // which the server's email check rejects.
  email: Yup.string().trim().email("Enter a valid email address").required("Required"),
  password: Yup.string()
    .required("Required")
    .when("isRegister", ([isRegister], sch) =>
      isRegister
        ? sch
            .max(PASSWORD_MAX, `At most ${PASSWORD_MAX} characters`)
            .test("password-rules", "Your password needs everything on the list below", (pw) => meetsPasswordRules(pw || ""))
        : sch
    ),
  rememberMe: Yup.boolean().optional(),
  isRegister: Yup.boolean().default(false),
  confirmPassword: Yup.string().when("isRegister", ([isRegister], sch) =>
    isRegister ? sch.oneOf([Yup.ref("password")], "Passwords must match").required("Required") : sch.notRequired()
  ),
});
